import React from 'react';
import { Map, CheckCircle2 } from 'lucide-react';
export function SolutionSection() {
  return <section className="w-full bg-gradient-to-b from-navy-light to-navy py-24 px-4 border-y border-gold/20" data-id="element-137" data-mp="3aa1183v3c1s0">
      <div className="max-w-5xl mx-auto text-center" data-id="element-138" data-mp="3o9k9cwnwjd4b">
        <div className="inline-flex items-center gap-2 text-gold font-bold tracking-widest uppercase mb-6" data-id="element-139" data-mp="3o6xt88my3pah">
          <Map className="w-5 h-5" data-id="element-140" data-mp="14kxx61rmxl6" />
          <span data-id="element-141" data-mp="13j8txnx0akg">Sección 3: El Mecanismo Único</span>
        </div>

        <h2 className="text-4xl md:text-6xl font-headline font-bold text-white mb-8 leading-tight" data-id="element-142" data-mp="3t8dh08gic9wk">
          He codificado el proceso en lo que llamo <br data-id="element-143" data-mp="at2t97ra0chf" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold via-yellow-200 to-gold text-glow" data-id="element-144" data-mp="atw0e9u5d403">
            La Ruta Crítica 8-16
          </span>
        </h2>

        <div className="max-w-3xl mx-auto text-xl text-gray-300 mb-12 leading-relaxed" data-id="element-145" data-mp="ktd80wsylryp">
          <p className="mb-6" data-id="element-146" data-mp="fujsyzy0xswf">
            No es un curso de entrenamiento.{' '}
            <span className="text-white font-bold" data-id="element-147" data-mp="36b5hqqyyx0c6">
              Es un Mapa de Inteligencia.
            </span>
          </p>
          <p data-id="element-148" data-mp="3bai5ddxnybft">
            Es el mismo sistema que utilizan las familias que logran becas de
            $40,000 al año o contratos en academias profesionales, pero
            simplificado para el padre trabajador que no tiene tiempo que
            perder.
          </p>
        </div>

        <div className="bg-navy border border-gold/30 rounded-2xl p-8 md:p-12 relative overflow-hidden group hover:border-gold/60 transition-colors duration-500" data-id="element-149" data-mp="3pa9n9prawbz3">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-150" data-mp="2tvpij6pdcqn" />

          <p className="text-sm text-cyan font-bold uppercase tracking-[0.2em] mb-4" data-id="element-151" data-mp="6vqqfmkq1o3w">
            Presentamos
          </p>

          <h3 className="text-3xl md:text-5xl font-headline font-bold text-white mb-6" data-id="element-152" data-mp="bw4yv5q8j02g">
            EL MÉTODO "BECA PRO": <br className="md:hidden" data-id="element-153" data-mp="gty2ps42fhzk" />
            <span className="text-gold" data-id="element-154" data-mp="2cwjmqkz5is9t">RUTA CRÍTICA 8-16</span>
          </h3>

          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-155" data-mp="2cugml84abird">
            El Blueprint exacto para sacar a tu hijo de la banca y ponerlo en el
            radar de los que deciden.
          </p>

          <div className="mt-8 flex justify-center" data-id="element-156" data-mp="2mofp4889t4ju">
            <CheckCircle2 className="w-12 h-12 text-gold opacity-80" data-id="element-157" data-mp="2hv4cfqgs1tk0" />
          </div>
        </div>
      </div>
    </section>;
}